export default __webpack_public_path__ + "static/media/reglogin-m-bg-id.57198b7f.webp";